import { render, staticRenderFns } from "./pickup_page.vue?vue&type=template&id=d22d5fac&"
import script from "./pickup_page.vue?vue&type=script&lang=js&"
export * from "./pickup_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports